import type { FunctionComponent } from 'react'
import React, { useContext as useContextCore } from 'react'
import { queries } from './graphql'
import { useList } from '@ztechapps/common.hook'
import type { ListQueryResult } from '@ztechapps/common.hook'
import type { Blog } from '@ztechapps/common.contract'

export type ProviderProps = {
  children: React.ReactNode
}

export type ContextType = Omit<ProviderProps, 'children'> & ListQueryResult<Blog>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider: FunctionComponent<ProviderProps> = ({ children, ...props }) => {
  const filter = { status: 'Active', tags: { $in: ['use-and-care'] } }
  const sort = { updatedAt: -1 as const }
  const listResult = useList<Blog>({
    ...queries.allConfig,
    filter,
    sort,
  })

  const value = {
    ...props,
    ...listResult,
    sort,
    filter,
  }

  return <CoreProvider value={value}>{children}</CoreProvider>
}

export const useContext = (): ContextType => useContextCore(context)
